<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-navbar toggleable="xl" style="padding: 0.5rem 0.43rem !important;" class="d-flex justify-content-start">
      <span class="logo-iniciales">{{ usrName | formatoIniciales}}</span>
      <span style="font-size: 0.90em; text-align: center">{{ usrName }} <br><span  style="color: #8a8a8a;     margin-left: 1vh;">  {{ fechaModificacion | formatoFechaHoraTexto }}</span></span>
    </b-navbar>
  </div>

</template>

<script>
export default {
  name: "logoUsuario",
  props: {
    usrName:String,
    fechaModificacion:String
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }


};
</script>
<style scoped>
</style>
